import React, { useEffect } from "react";
import "./Successfull_strip_modal.css";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

function Successfull_strip_modal({ show, onHide, textMsg, ...props }) {

  const navigate = useNavigate();

  useEffect(() => {
    // if (show) {
    //   const timer = setTimeout(() => {
    //     onHide();           // Close modal
    //     navigate("/login"); // Redirect to login
    //   }, 3000);

    //   return () => clearTimeout(timer);
    // }
  }, [show, onHide, navigate]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="sm"
      className="Successfull_strip_modal"
      {...props}
    >
      <Modal.Body>
        <div className="Successfull_strip">
          <h3>{textMsg}</h3>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default Successfull_strip_modal;